import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
// import Button from './button';
import Button from './button_group';


@mixin.decorate(window.CssClassMixin)
export default class ButtonGroup extends React.Component {
	static propTypes = {
		buttons: PropTypes.array
	};

	static defaultProps = {
		themeClassKey: 'button.group',
		buttons: []
	};

	renderButtons() {
		var buttonsProps = this.props.buttons;
		var buttons = [];

		for(var i = 0; i < buttonsProps.length; i++) {
			var buttonProps = buttonsProps[i];
			buttons.push(<Button {...buttonProps} key={"button_" + i}  role='button'/>);
		}

		return buttons;
	}

	render() {
		return (
			<div className={this.className()}>
			{this.renderButtons()}
			</div>
		);
	}
}
